import {apiList, $axios} from "@/api";

export default {
    namespaced: true,
    state: () => ({
        formData: {
            mailTag: null,
            subject: '',
            courseName: '',
            selectedCategoryValue: null,
            step: { n: 1, cat: null }
        }
    }),

    mutations: {
        setFormData(state, payload) {
            state.formData = {
                ...state.formData,
                ...payload
            };
        },

        clearFormData(state) {
            state.formData = {
                mailTag: null,
                subject: '',
                courseName: '',
                selectedCategoryValue: null,
                step: { n: 1, cat: null }
            };
        }
    },

    actions: {
        saveFeedbackFormData({ commit }, payload) {
            commit('setFormData', payload);
        },

        clearFeedbackFormData({ commit }) {
            commit('clearFormData');
        },

        getFeedbackQuestions(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.feedback.getFeedbackQuestions.method,
                    params: {
                        wsfunction: apiList.feedback.getFeedbackQuestions.moodle_method,
                        feedbackid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        launchFeedback(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.feedback.launchFeedback.method,
                    params: {
                        wsfunction: apiList.feedback.launchFeedback.moodle_method,
                        feedbackid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        markFeedbackAsViewed(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.feedback.setViewFeedback.method,
                    params: {
                        wsfunction: apiList.feedback.setViewFeedback.moodle_method,
                        feedbackid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getLastCompletedFeedback(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.feedback.getLastCompletedFeedback.method,
                    params: {
                        wsfunction: apiList.feedback.getLastCompletedFeedback.moodle_method,
                        feedbackid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getFeedbackAccessInfo(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.feedback.getFeedbackAccessInfo.method,
                    params: {
                        wsfunction: apiList.feedback.getFeedbackAccessInfo.moodle_method,
                        feedbackid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        processFeedback(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.feedback.processFeedback.method,
                    params: {
                        wsfunction: apiList.feedback.processFeedback.moodle_method,
                        feedbackid: payload.id,
                        page: 0,
                        courseid: 4,
                        ...payload.data
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
